import { message } from "antd";
import { useTranslation } from "react-i18next";
import Badge from "components/badge";

const Copy = ({ data }) => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const handleCopyMsg = () => {
    return messageApi.open({
      type: "success",
      content: t("coppied"),
      className: "body-14px-medium",
    });
  };

  const copyTextToClipboard = async () => {
    if ("clipboard" in navigator) {
      handleCopyMsg();
      return await navigator.clipboard.writeText(data);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="flex items-center ">
        <span className="text-gray-4 caption-12px-bold ml-1">{data || 0}</span>
        <Badge
          type="blue-large"
          content={t("copy")}
          action={copyTextToClipboard}
        />
      </div>
    </>
  );
};
export default Copy;
